module.exports = __webpack_public_path__ + "static/media/time.109066bd.svg";